// @flow
import axios from 'lib/defaultClient';

export const like = (bannerId: string) => axios.post(`/banners/${bannerId}/like`);

export const unlike = (bannerId: string) => axios.delete(`/banners/${bannerId}/like`);

export const getLikesCount = (bannerId: string) => axios.get(`/banners/${bannerId}/like`);



// WEBPACK FOOTER //
// ./src/lib/api/banners/like.js